import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithLogOut } from "./genioBaseQuery";

export const genioxxxApiSlice = createApi({
  reducerPath: "genioxxxApiSlice",
  baseQuery: baseQueryWithLogOut,
  endpoints: (builder) => ({
   loginGenio: builder.mutation({
      query: (credentials) => ({
        url: "/login",
        method: "POST",
        body: {
          USRIDXXX: credentials.USRIDXXX,
          USRPASXX: credentials.USRIDXXX,
          external: true,
          SISTEMAX: process.env.REACT_APP_GENIO_NAME,
        },
        credentials: "include",
      }),
    }),
    createPackagePresigned: builder.mutation({
      query: (parameters) => ({
        url: "/paquetedocumentalperfirmados",
        method: "POST",
        body: parameters,
      }),
    }),
    confirmPackagePresigned: builder.mutation({
      query: ({ path, body }) => ({
        url: "/paquetedocumentalconfirmacion/" + path.IDARCHXX,
        method: "PUT",
        body: body,
      }),
    }),
    createPackage: builder.mutation({
      query: (parameters) => ({
        url: "/paquetesdocumentales",
        method: "POST",
        body: parameters,
      }),
    }),
    updatePackage: builder.mutation({
      query: (parameters) => ({
        url: `/paquetesdocumentales/${parameters.IDARCHXX}`,
        method: "PUT",
        body: parameters,
      }),
    }),
    getTipometadatos: builder.query({
      query: ({ EMPNITXX, AREAIDXX, SERIEIDX, TIPOIDXX, METS = ['FECINICI', 'FECHAFIN', 'DEVIGDE', 'FEVIGHAS'] }) => {
        const qs = new URLSearchParams();
        qs.set('sorts', '-TIPOIDXX');
        qs.set('filters[GEST0008.REGESTXX]', 'ACTIVO');
        // METS null/vacío = todos los metadatos del tipo (sin filtro de campo)
        if (Array.isArray(METS) && METS.length > 0) {
          qs.set('filters[GEST0008.METIDXXX][IN]', METS.join(','));
        }
        if (EMPNITXX) qs.set('filters[GEST0008.EMPNITXX]', EMPNITXX);
        if (AREAIDXX) qs.set('filters[GEST0008.AREAIDXX]', AREAIDXX);
        if (SERIEIDX) qs.set('filters[GEST0008.SERIEIDX]', SERIEIDX);
        if (TIPOIDXX) qs.set('filters[GEST0008.TIPOIDXX]', TIPOIDXX);
        return `tipometadatos?${qs.toString()}`;
      },
    }),
    getMetadatosCatalog: builder.query({
      query: ({ METIDS = [] }) => {
        const qs = new URLSearchParams();
        qs.set('filters[REGESTXX]', 'ACTIVO');
        if (METIDS.length > 0) {
          qs.set('filters[METIDXXX][IN]', METIDS.join(','));
        }
        return `metadatos?${qs.toString()}`;
      },
    }),
    paquetesDocumentales: builder.query({
      query: (parameters) => ({
        url: "/paquetesdocumentales",
        method: "GET",
        params: { ...parameters },
      }),
    }),
    getAreasGestor: builder.query({
      query: (parameters) => ({
        url: `/areas`,
        method: "GET",
      }),
      invalidatesTags: ["reset"],
    }),
    getSeriesByAreaGestor: builder.query({
      query: (parameters) => ({
        url: `/areasxseries?sorts=-SERIEIDX&filters[EMPNITXX]=${parameters.EMPNITXX}&filters[AREAIDXX]=${parameters.AREAIDXX}&filters[regestxx]=ACTIVO`,
        method: "GET",
      }),
    }),
    getTypesBySerieGestor: builder.query({
      query: (parameters) => ({
        url: `/serieportipos?sorts=-TIPOIDXX&filters[EMPNITXX]=${parameters.EMPNITXX}&filters[AREAIDXX]=${parameters.AREAIDXX}&filters[SERIEIDX]=${parameters.SERIEIDX}&filters[regestxx]=ACTIVO`,
        method: "GET",
      }),
    }),
    getTypeGestor: builder.query({
      query: (parameters) => ({
        url: `/serieportipos/${parameters.EMPNITXX}/${parameters.AREAIDXX}/${parameters.SERIEIDX}/${parameters.TIPOIDXX}`,
        method: "GET",
      }),
    }),
    getProcessCompany: builder.query({
      query: (parameters) => ({
        url: `/empresaAreas?` + parameters.filters,
        method: "GET",
      }),
    }),
    getAreasByFilter: builder.mutation({
      query: (parameters) => ({
        url: `/areas`,
        method: "GET",
        params: parameters
      }),
    }),
    getSeriesByFilter: builder.query({
      query: (parameters) => ({
        url: `/areasxseries`,
        method: "GET",
        params: parameters
      }),
    }),
    getTiposByFilter: builder.query({
      query: (parameters) => ({
        url: `/serieportipos`,
        method: "GET",
        params: parameters
      }),
    }),
    getCustomsMandateByClient: builder.query({
      query: (parameters) => ({
        url: `/getCustomsmandateByClient/` + parameters.CLIIDXXX,
        method: "GET",
      }),
    }),
    getDocumentProductClassification: builder.query({
      query: (parameters) => ({
        url: `/getProductClassification/${parameters.CLIIDXXX}?sorts=-REGFECXX&filters[EMPNITXX]=${parameters.EMPNITXX}&filters[AREAIDXX]=${parameters.AREAIDXX}&filters[SERIEIDX]=${parameters.SERIEIDX}&filters[REGESTXX]=ACTIVO`,
        method: "GET",
      }),
    }),
    getEmpresas: builder.query({
      query: () => ({
        url: `/empresasOpciones`,
        method: "GET",
      }),
    }),
    getTypes: builder.query({
      query: (parameters) => ({
        url: "/tipos",
        method: "GET",
        params: { ...parameters },
      }),
    }),
    getTiposByDescripByFilter: builder.query({
      query: (parameters) => ({
        url: `/getTypeByDes?sorts=-TIPOIDXX&filters[EMPNITXX]=${parameters.EMPNITXX}&filters[AREAIDXX]=${parameters.AREAIDXX}&filters[SERIEIDX]=${parameters.SERIEIDX}&filters[TIPOIDXX]=${parameters.TIPOIDXX}&filters[regestxx]=ACTIVO`,
        method: "GET",
      }),
    }),
    resendDasHp: builder.mutation({
      query: ({ DOCNROXX, REGESTXX }) => ({
        url: `/ReagendarDasHp/${DOCNROXX}`,
        method: "PUT",
        body: {
          REGESTXX,
        },
      }),
    }),
    getClientDocComplete: builder.query({
      query: () => ({
        url: `/getClientDocComplete`,
        method: "GET",
      }),
    }),
    createReport: builder.mutation({
      query: (parameters) => ({
        url: `/crearReporte`,
        method: "POST",
        body: parameters,
      }),
    }),
    createReports: builder.mutation({
      query: (parameters) => ({
        url: `/crearReportes`,
        method: "POST",
        body: parameters,
      }),
    }),
    getJerarquiaDocumental: builder.mutation({
      query: ({ ids = [], anio }) => {
        const params = new URLSearchParams();
        ids.forEach((id) => params.append("ids[]", id));
        if (anio) params.set("anio", anio);
        return {
          url: `/getJerarquiaDocumental?${params.toString()}`,
          method: "GET",
        };
      },
    }),

  }),
});

// auto-generated based on the defined endpoints
export const {
  useLoginGenioMutation,
  useConfirmPackagePresignedMutation,
  useLazyGetTipometadatosQuery,
  useLazyGetMetadatosCatalogQuery,
  useCreatePackagePresignedMutation,
  useCreatePackageMutation,
  useUpdatePackageMutation,
  useGetEmpresasQuery,
  useLazyPaquetesDocumentalesQuery,
  useGetAreasGestorQuery,
  useGetProcessCompanyQuery,
  useLazyGetSeriesByAreaGestorQuery,
  useLazyGetTypesBySerieGestorQuery,
  useLazyGetTypesQuery,
  useLazyGetProcessCompanyQuery,
  useLazyGetTypeGestorQuery,
  useGetAreasByFilterMutation,
  useLazyGetSeriesByFilterQuery,
  useLazyGetTiposByFilterQuery,
  useLazyGetCustomsMandateByClientQuery,
  useLazyGetDocumentProductClassificationQuery,
  useLazyGetTiposByDescripByFilterQuery,
  useResendDasHpMutation,
  useGetClientDocCompleteQuery,
  useCreateReportMutation,
  useCreateReportsMutation,
  useGetJerarquiaDocumentalMutation,
} = genioxxxApiSlice;
